import { useState } from 'react';
import { Link } from 'react-router-dom';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../lib/firebase.js';
import SocHeader from '../components/SocHeader.jsx';
import Footer from '../components/Footer.jsx';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr('');
    setMsg(null);
    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, email.trim());
      setMsg('Reset link transmitted. Check your inbox (and spam folder).');
    } catch (error) {
      setErr(error.message.replace('Firebase: ', ''));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SocHeader />
      <section className="auth-section" id="main">
        <div className="auth-card">
          <div className="hero-eyebrow">CREDENTIAL RESET</div>
          <h2 className="auth-headline">Forgot Password</h2>
          <p className="auth-sub">Enter your email — we'll send a reset link.</p>

          {err && <div className="form-msg error">ERROR — {err}</div>}
          {msg && <div className="form-msg success">CONFIRMED — {msg}</div>}

          <form onSubmit={onSubmit} className="contact-form">
            <div className="form-group">
              <label className="form-label" htmlFor="email">Email</label>
              <input id="email" type="email" className="form-input" autoComplete="email" required
                value={email} onChange={(e) => setEmail(e.target.value)} placeholder="OPERATOR@DOMAIN" />
            </div>
            <button type="submit" className="btn btn-block" disabled={loading}>
              {loading ? 'TRANSMITTING…' : 'Send Reset Link →'}
            </button>
          </form>

          <div className="auth-links">
            <Link to="/signin">Back to Sign In</Link>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
